/**
 * 
 * @returns {JSX.Element} div with some styling to hold jsx for inputs
 * 
 * @category Components - UI
 */
export const InputContainer = ({children}) => {
    return (

        //using a style attribute here because using tailwind mb class is overriden in this component, due to how tailwind works under the hood with vertical spacing 

        <div className="flex flex-col" style={{marginBottom: "1.5rem"}}>{children}</div>
    )
}


/**
 * 
 * @returns {JSX.Element} div with some styling for displaying inputs in rows at larger screen sizes, columns at smaller screen sizes
 * 
 * @category Components - UI
 */
export const InputRow = ({children}) => {
    return (
        <div className="flex flex-col md:flex-row">{children}</div>
    )
}